import api from "../middlware/api";
import { BASE_URL } from "../constants";

export const getRooms = (params?: any) => {
  return new Promise((resolve, reject) => {
    let query = new URLSearchParams();
    if (params) {
      for (let key in params) {
        if (params[key] !== undefined && params[key] !== null && params[key] !== "") {
          query.set(key, params[key]);
        }
      }
    }
    const queryString = query.toString();
    const url = queryString 
      ? `${BASE_URL}/api/v1/rooms?${queryString}`
      : `${BASE_URL}/api/v1/rooms`;
    
    api
      .get(url)
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  });
};

export const addRoom = (payload: { name: string; floor: number; room_type_id: number, status: string }) => {
  return new Promise((resolve, reject) => {
    api
      .post(`${BASE_URL}/api/v1/rooms`, payload)
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  });
};

export const getRoomTypes = (params?: any) => {
  return new Promise((resolve, reject) => {
    api
      .get(`${BASE_URL}/api/v1/room-types`, { params })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  });
};


export const addRoomType = (payload: {
  name: string;
  price_per_hour: number;
  price_per_day: number;
}) => {
  return api.post(`${BASE_URL}/api/v1/room-types`, payload);
};


